import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';

@Entity('facturation')
export default class Facturation {
    static key = 'facturation';

    static non_privileged_properties: (keyof Facturation)[] = [];
    static regular_privileged_properties: (keyof Facturation)[] = [];
    static admin_privileged_properties: (keyof Facturation)[] = [];

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    methode_facturation: string;

    @Column({ type: 'numeric', nullable: true })
    prix_de_vente_fournisseur: number;

    @Column({ type: 'numeric', nullable: true })
    valeur_commission_dollar: number;

    @Column({ type: 'numeric', nullable: true })
    valeur_commission_pourcentage: number;

    @Column({ type: 'numeric', nullable: true })
    valeur_surfacturation_dollar: number;

    @Column({ type: 'numeric', nullable: true })
    valeur_surfacturation_pourcentage: number;

    @Column({ name: 'b_taxable', nullable: true, default: true })
    b_taxable: boolean;
}
